import {
  CalendarOutlined,
  PlusOutlined,
  ForkOutlined,
  TeamOutlined
} from '@ant-design/icons';

export const care_types = [
    {
        'key': 0,
        'label': "Jour d'affectation des soins",
        'icon': (<CalendarOutlined />),
        'children': [],
        'fields': [{
          'key': 'action_time',
          'label': null,
          'type': 'date',
        }],
    }, {
        'key': 1,
        'label': "Soins de base",
        'icon': (<PlusOutlined />),
        'children': [
            {
                'key': 0,
                'label': 'Alimentation',
                'fields': [
                    {
                        'key': 1,
                        'label': 'Autonomie',
                        'type': 'bool'
                    }, {
                        'key': 2,
                        'label': 'Installation / incitation',
                        'type': 'bool'
                    }, {
                        'key': 3,
                        'label': 'Boissons fréquentes',
                        'type': 'bool'
                    }, {
                        'key': 4,
                        'label': 'Dépendance alimentaire totale',
                        'type': 'bool'
                    }
                ]
            }, {
                'key': 1,
                'label': 'Locomotion',
                'fields': [
                    {
                        'key': 5,
                        'label': 'Autonomie',
                        'type': 'bool'
                    }, {
                        'key': 6,
                        'label': 'Installation / Incitation',
                        'type': 'bool',
                    }, {
                        'key': 7,
                        'label': 'Aide pour le lever',
                        'type': 'bool',
                    }, {
                        'key': 8,
                        'label': 'Aide pour la marche',
                        'type': 'bool',
                    }, {
                        'key': 9,
                        'label': 'Aide pour la mise au fauteuil',
                        'type': 'bool',
                    }, {
                        'key': 10,
                        'label': 'Alitement permanent',
                        'type': 'bool',
                    }
                ],
            }, {
                'key': 2,
                'label': 'Élimination',
                'fields': [
                    {
                        'key': 11,
                        'label': 'Autonomie',
                        'type': 'bool',
                    }, {
                        'key': 12,
                        'label': 'Installation / Incitation',
                        'type': 'bool',
                    }, {
                        'key': 13,
                        'label': 'Changes occasionnels',
                        'type': 'bool',
                    }, {
                        'key': 14,
                        'label': 'Changes fréquents',
                        'type': 'bool',
                    }
                ]
            }, {
                'key': 3,
                'label': 'Hygiène et confort',
                'fields': [
                    {
                        'key': 15,
                        'label': 'Autonomie',
                        'type': 'bool',
                    }, {
                        'key': 16,
                        'label': 'Petits soins d\'hygiène',
                        'type': 'bool',
                    }, {
                        'key': 17,
                        'label': 'Dépilation',
                        'type': 'bool',
                    }, {
                        'key': 18,
                        'label': 'Prévention escarre',
                        'type': 'bool',
                    }, {
                        'key': 19,
                        'label': 'Toilette complète',
                        'type': 'bool',
                    }, {
                        'key': 20,
                        'label': 'Changement de position fréquent',
                        'type': 'bool',
                    }, {
                        'key': 70,
                        'label': 'Préparation Bloc',
                        'type': 'bool',
                    }
                ]
            }
        ]
    }, {
        'key': 2,
        'label': 'Soins techniques',
        'icon': (<ForkOutlined />),
        'children': [
            {
                'key': 0,
                'label': 'Surveillance des constantes',
                'fields': [
                    {
                        'key': 21,
                        'label': 'Nombre de surveillance des constantes',
                        'type': 'int',
                        'min': 0,
                        'max': 20,
                        'values': ['0-3', '4-7', '8-12', '12+'],
                    }
                ]
            }, {
                'key': 1,
                'label': 'Pansements / Soins',
                'fields': [
                    {
                        'key': 22,
                        'label': 'Soins de bouche',
                        'type': 'bool',
                    }, {
                        'key': 23,
                        'label': 'ECG / Pose de Holter',
                        'type': 'bool',
                    }, {
                        'key': 24,
                        'label': 'Instillations oculaires',
                        'type': 'bool',
                    }, {
                        'key': 25,
                        'label': 'Soins préopératoires',
                        'type': 'bool',
                    }, {
                        'key': 26,
                        'label': 'Aérosols',
                        'type': 'bool',
                    }, {
                        'key': 27,
                        'label': 'Extension de fractures',
                        'type': 'bool',
                    }, {
                        'key': 28,
                        'label': 'Aspirations trachéales itératives',
                        'type': 'bool',
                    }, {
                        'key': 29,
                        'label': 'Assistance continue',
                        'type': 'bool',
                    }, {
                        'key': 75,
                        'label': 'Réfection pansement VVC / Picc-Line',
                        'type': 'bool',
                    }, {
                        'key': 76,
                        'label': 'Surveillance lambeau / plastie',
                        'type': 'bool',
                    }, {
                        'key': 30,
                        'label': 'Pansements simples',
                        'type': 'int',
                        'values': ['0-3', '4-5'],
                        'min': 0,
                        'max': 5
                    }, {
                        'key': 31,
                        'label': 'Pansements complexes',
                        'type': 'int',
                        'values': ['0-3', '4-5'],
                        'min': 0,
                        'max': 5
                    }
                ]
            }, {
                'key': 2,
                'label': 'Prélèvements / Injections / Traitements',
                'fields': [
                    {
                        'key': 32,
                        'label': 'Prélèvements ou injections',
                        'type': 'int',
                        'values': ['0-3', '4-6', '6+'],
                        'min': 0,
                        'max': 10
                    }, {
                        'key': 33,
                        'label': 'Traitement per os',
                        'type': 'bool',
                    }, {
                        'key': 34,
                        'label': 'Perfusions lourdes + diurèse',
                        'type': 'bool',
                    }, {
                        'key': 71,
                        'label': 'Pose de Voie Veineuse Périphérique',
                        'type': 'bool',
                    }, {
                        'key': 72,
                        'label': 'Pose / Changement de gripper sur chambre implantable',
                        'type': 'bool',
                    }
                ]
            }, {
                'key': 3,
                'label': 'Tubage / Ponction / Biopsie',
                'fields': [
                    {
                        'key': 35,
                        'label': 'Pose ou surveillance sonde naso-gastrique',
                        'type': 'bool',
                    }, {
                        'key': 36,
                        'label': 'Pose ou surveillance sonde urinaire',
                        'type': 'bool',
                    }, {
                        'key': 37,
                        'label': 'Aide pour ponction - biopsie',
                        'type': 'bool',
                    }, {
                        'key': 38,
                        'label': 'Patients multi-appareillés',
                        'type': 'bool',
                    }, {
                        'key': 39,
                        'label': 'Cathéter cardiaque',
                        'type': 'bool',
                    }, {
                        'key': 40,
                        'label': 'Cathéter périnerveux',
                        'type': 'bool',
                    }, {
                        'key': 41,
                        'label': 'Cathéter péridural',
                        'type': 'bool',
                    }, {
                        'key': 42,
                        'label': 'Plasmaphérèse',
                        'type': 'bool',
                    }, {
                        'key': 73,
                        'label': 'Surveillance VVP, VVC, Picc-Line',
                        'type': 'bool',
                    }, {
                        'key': 74,
                        'label': 'Surveillance / irrigation - drain / redon',
                        'type': 'bool',
                    }
                ]
            }, {
                'key': 4,
                'label': 'Stomies',
                'fields': [
                    {
                        'key': 43,
                        'label': 'Stomie digestive ou urinaire simple',
                        'type': 'bool',
                    }, {
                        'key': 44,
                        'label': 'Stomie digestive ou urinaire complexe',
                        'type': 'bool',
                    }, {
                        'key': 45,
                        'label': 'Trachéostomie',
                        'type': 'bool',
                    }
                ]
            }
        ],
    }, {
        'key': 3,
        'label': 'Soins relationnels et éducatifs',
        'icon': (<TeamOutlined />),
        'children': [
            {
                'key': 0,
                'label': 'Information / Instruction',
                'fields': [
                    {
                        'key': 46,
                        'label': 'Autonomie',
                        'type': 'bool',
                    }, {
                        'key': 47,
                        'label': 'Informations succinctes et ponctuelles',
                        'type': 'bool',
                    }, {
                        'key': 48,
                        'label': 'Instruction sur problème de santé',
                        'type': 'bool',
                    }, {
                        'key': 49,
                        'label': 'Instruction sur un régime',
                        'type': 'bool',
                    }, {
                        'key': 50,
                        'label': 'Reformulation et explications intératives',
                        'type': 'bool',
                    }
                ]
            }, {
                'key': 1,
                'label': 'Relation d\'aide',
                'fields': [
                    {
                        'key': 51,
                        'label': 'Autonomie',
                        'type': 'bool',
                    }, {
                        'key': 52,
                        'label': 'Aide à la vie quotidienne',
                        'type': 'bool',
                    }, {
                        'key': 53,
                        'label': 'Aide à la vie hospitalière',
                        'type': 'bool',
                    }, {
                        'key': 54,
                        'label': 'Aide contre l\'anxiété et/ou la solitude',
                        'type': 'bool',
                    }, {
                        'key': 55,
                        'label': 'Réflexologie plantaire et soins d\'apaisement et de confort',
                        'type': 'bool',
                    }, {
                        'key': 56,
                        'label': 'En situations et relations difficiles',
                        'type': 'bool',
                    }, {
                        'key': 57,
                        'label': 'En situations de crise',
                        'type': 'bool',
                    }
                ]
            }, {
                'key': 2,
                'label': 'Comportement patient',
                'fields': [
                    {
                        'key': 58,
                        'label': 'Autonomie',
                        'type': 'bool',
                    }, {
                        'key': 59,
                        'label': 'Observation du comportement',
                        'type': 'bool',
                    }, {
                        'key': 60,
                        'label': 'Sonnettes et appels multiples',
                        'type': 'bool',
                    }, {
                        'key': 61,
                        'label': 'Dépression',
                        'type': 'bool',
                    }, {
                        'key': 62,
                        'label': 'Angoisse majeure',
                        'type': 'bool',
                    }, {
                        'key': 63,
                        'label': 'Stimulation fréquente pour reprise de conscience',
                        'type': 'bool',
                    }, {
                       'key': 64,
                       'label': 'Désorientation',
                       'type': 'bool',
                    }, {
                       'key': 65,
                       'label': 'Agitation extrême',
                       'type': 'bool',
                    }, {
                       'key': 66,
                       'label': 'Décès',
                       'type': 'bool',
                    }
                ]
            }, {
                'key': 3,
                'label': 'Apprentissage',
                'fields': [
                    {
                        'key': 67,
                        'label': 'Autonomie',
                        'type': 'bool',
                    }, {
                        'key': 68,
                        'label': 'Auto-soins à la personne soignée ou à la famille',
                        'type': 'bool',
                    }, {
                        'key': 69,
                        'label': 'Changes fréquents',
                        'type': 'bool',
                    }, {
                        'key': 77,
                        'label': 'Education thérapeutique patient / Famille',
                        'type': 'bool',
                    }, {
                        'key': 78,
                        'label': 'En cours d’éducation',
                        'type': 'bool',
                    }, {
                        'key': 79,
                        'label': 'Non-autonome',
                        'type': 'bool',
                    }
                ]
            }
        ]
    }
]